import { c as _c } from "react/compiler-runtime";
import Typography from '@classify/react-core-components/Typography';
import type { ContentData } from './services';
const variants = ['h2', 'h3', 'h4', 'subheading', 'bodySmall'] as const;
type ContentTitleProps = {
  contentData: ContentData;
};
export default function ContentTitle(t0) {
  const $ = _c(5);
  const {
    contentData
  } = t0;
  const id = contentData.anchor ? contentData.anchor : `policy_${contentData.id}`;
  const depth = Math.min(contentData.depth, variants.length - 1);
  const t1 = variants[depth];
  const t2 = `h${depth + 1}` as React.ElementType;
  const t3 = `_${id}`;
  let t4;
  if ($[0] !== contentData.content || $[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
    t4 = <Typography gutterBottom={true} variant={t1} component={t2} id={t3}>{contentData.content}</Typography>;
    $[0] = contentData.content;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}